module.exports = __webpack_public_path__ + "img/logo_annex_col_white.a8f57497.png";